var NotificationVariant;
(function (NotificationVariant) {
    NotificationVariant["Success"] = "success";
    NotificationVariant["Error"] = "error";
})(NotificationVariant || (NotificationVariant = {}));
export var mapToNotificationsOptions = function (_a) {
    var isFailed = _a.isFailed, onFailed = _a.onFailed, onSuccess = _a.onSuccess;
    var _b = isFailed
        ? [NotificationVariant.Error, onFailed()]
        : [NotificationVariant.Success, onSuccess()], variant = _b[0], message = _b[1];
    return { variant: variant, message: message };
};
